import styles from "./styles.module.scss";

interface PageTopperProps {
  headline: string;
  dek?: string;
}

export function PageTopper({ headline, dek }: PageTopperProps) {
  return (
    <div className={styles.container}>
      <h1 className={styles.headline}>{headline}</h1>
      {dek && <p className={styles.dek}>{dek}</p>}
    </div>
  );
}
